import { memo } from 'react';
import { useModal } from 'commons/hooks';
import {
  MainMenu,
  AccountMenu,
  SettingsMenu,
  HelpMenu,
  BillingMenu,
} from './components';
import { useMenuOptionsVisibility } from './hooks';
import './Menu.scss';

interface MenuProps {
  device: 'mobile' | 'desktop';
}

function Menu({ device }: MenuProps): JSX.Element {
  const [isVisibleSupport, showVisibleSupport, hiddenVisibleSupport] =
    useModal();

  const { isVisibleAccount, isVisibleSettings, isVisibleBilling } =
    useMenuOptionsVisibility();

  return (
    <>
      <MainMenu device={device} onClickSupport={showVisibleSupport} />
      <HelpMenu onClose={hiddenVisibleSupport} visible={isVisibleSupport} />
      <AccountMenu visible={isVisibleAccount} device={device} />
      <SettingsMenu visible={isVisibleSettings} />
      <BillingMenu visible={isVisibleBilling} />
    </>
  );
}

export default memo(Menu);
